module.exports = __webpack_public_path__ + "static/img/30008 (2).4102a78.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30008 (2).webp
// module id = +DTM
// module chunks = 14